import React, { useEffect, useState } from 'react'
import moment from 'moment'
import * as AnalyticsService from '../../services/analytics'
import { useAnalyticsFilters } from '../../contexts/AnalyticsFilterContext'
import AnalyticsPageShell from './components/AnalyticsPageShell'
import InsightsPanel from './components/InsightsPanel'
import BarSeriesChart from './components/BarSeriesChart'
import { SectionCard, SectionTitle } from './styles'
import { formatNumber, getAnalyticsErrorMessage } from './utils'

const ChipList = ({ items = [], emptyLabel }) => {
    if (!items.length) {
        return <div style={{ color: 'var(--text-tertiary)', fontSize: 14 }}>{emptyLabel}</div>
    }
    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {items.map((item) => (
                <span
                    key={item}
                    style={{
                        background: 'var(--background-paper)',
                        border: '1px solid var(--divider-contrast)',
                        borderRadius: 4,
                        padding: '4px 8px',
                        fontSize: 12,
                        fontWeight: 600
                    }}
                >
                    {item}
                </span>
            ))}
        </div>
    )
}

const System = () => {
    const { rangeFilters } = useAnalyticsFilters()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [data, setData] = useState(null)

    useEffect(() => {
        let cancelled = false

        async function load() {
            setLoading(true)
            setError(null)
            try {
                const response = await AnalyticsService.getSystem(rangeFilters)
                if (!cancelled) setData(response)
            } catch (err) {
                if (!cancelled) setError(getAnalyticsErrorMessage(err))
            } finally {
                if (!cancelled) setLoading(false)
            }
        }

        load()
        return () => {
            cancelled = true
        }
    }, [rangeFilters])

    const lastEventLabel = data?.lastEventTime ? moment(data.lastEventTime).local().format('DD/MM/YYYY HH:mm:ss') : '—'

    return (
        <AnalyticsPageShell title='Análises de negócio — Sistema (cobertura)' loading={loading} error={error}>
            <SectionCard>
                <SectionTitle>Cobertura de gravação</SectionTitle>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 16 }}>
                    <div>
                        <div style={{ fontSize: 12, color: 'var(--text-secondary)', fontWeight: 600 }}>
                            Eventos no período
                        </div>
                        <div style={{ fontSize: 28, fontWeight: 700 }}>{formatNumber(data?.totalEventsInPeriod)}</div>
                    </div>
                    <div>
                        <div style={{ fontSize: 12, color: 'var(--text-secondary)', fontWeight: 600 }}>
                            Último evento
                        </div>
                        <div style={{ fontSize: 18, fontWeight: 700 }}>{lastEventLabel}</div>
                    </div>
                </div>
            </SectionCard>
            <SectionCard>
                <SectionTitle>Tipos gravados</SectionTitle>
                <ChipList items={data?.recordedEventTypes} emptyLabel='Nenhum tipo gravado no período.' />
            </SectionCard>
            <SectionCard>
                <SectionTitle>Tipos do sistema nunca gravados</SectionTitle>
                <ChipList
                    items={data?.enumTypesNeverRecorded}
                    emptyLabel='Todos os tipos do sistema já foram gravados ao menos uma vez.'
                />
            </SectionCard>
            <BarSeriesChart title='Volume por tipo' points={data?.volumeByType} color='#8884d8' height='340px' />
            <InsightsPanel insights={data?.insights} />
        </AnalyticsPageShell>
    )
}

export default System
